@if (registrationStatus$ | async; as registrationStatus) {
    @if (row()) {
        <div
            priva-card
            [hasHeader]="false"
            [hasBody]="true"
            [hasFooter]="false"
            headerSize="md"
            (click)="toggleRowSelectionAndFinishIfSingleSelection()"
            (contextmenu)="onContextMenu($event)"
            size="xs"
            [ngClass]="[
                'row',
                'row--status-' + registrationStatus,
                'row-' + ((isRowSelected$ | async) ? 'selected' : 'default'),
            ]"
            id="row-{{ row().number }}"
            data-test="map-row"
        >
            <div class="buttons-wrapper">
                <button
                    iconState="left"
                    class="for-registered-row row-name"
                    [iconClass]="getIconClassForRegistrationStatus(registrationStatus)"
                    importance="Tertiary"
                    priva-button
                >
                    {{ row().name }}
                </button>
                <button
                    iconState="none"
                    class="for-not-registered-row row-name"
                    importance="Tertiary"
                    priva-button
                >
                    {{ row().name }}
                </button>
                @if (isMultiSelectModeAllowed$ | async) {
                    <button
                        data-test="map-row-menu-button"
                        iconClass="fas fa-ellipsis-vertical"
                        iconState="Only"
                        importance="Tertiary"
                        priva-button
                        (click)="onMenuButtonClicked($event)"
                    ></button>
                }
            </div>
        </div>
    }
}
